"use client"

import { useState, useEffect } from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"

export default function ImageSlider() {
  const [currentSlide, setCurrentSlide] = useState(0)

  const slides = [
    {
      id: 1,
      image: "https://cdn.flabs.in/webassets/7f877b93d169dad1fd60.jpg",
      title: "पॅथॉलॉजी लॅब",
      description: "सर्व पॅथॉलॉजी तपासण्यांवर ५% ते ३०% सूट मिळवा.",
    },
    {
      id: 2,
      image: "https://content.jdmagicbox.com/v2/comp/talcher/z2/9999p6760.6760.191017000226.n8z2/catalogue/krishna-medicine-store-handidhua-talcher-chemists-tsgph42i6s-250.jpg",
      title: "औषधांची / मेडिकल दुकान",
      description: "औषधे / मेडिकल व वैद्यकीय साहित्यावर १०% ते ५०% सूट मिळवा",
    },
    {
      id: 3,
      image: "https://lh3.googleusercontent.com/gps-cs-s/AC9h4noS54kcrY9jDxmDbGEHdyDUtFdv69zkboO8bpsAwwH6HAQ_n211k7ayW7o_grgD_IMkEoNz7Bx6zRp5T1VxK7gZzq2DIE5sVICsHJAoEi3v8ro7kYxyOWiq5XIQRCM-ZrQBATcU7ZF60hWF=w141-h141-n-k-no-nu",
      title: "रुग्णालय / Hospital",
      description: "रुग्णालयाच्या बिलांवर कमाल २५% सूट मिळवा",
    },
    {
      id: 4,
      image: "https://lh3.googleusercontent.com/gps-cs-s/AC9h4npI-kgiXxpHMQ_rbu_qjOYG5pfKMLLUs6S9ksRiZaILDBRl4_TeWuJa5nVrGumYf_sXzkeoCtKIKOCwJl607CXN4q70jtOf46M-WlypcgCKavmW1sx-fSjRrQKmdSqNGTUNdg1YqxBSbjTD=s1360-w1360-h1020-rw",
      title: "मोफत आरोग्य शिक्षण",
      description: "आरोग्य शिक्षण पूर्णपणे मोफत उपलब्ध",
    },
  ]

  // Auto-slide functionality
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length)
    }, 5000) // Change slide every 5 seconds

    return () => clearInterval(timer)
  }, [slides.length])

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length)
  }

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length)
  }

  const goToSlide = (index) => {
    setCurrentSlide(index)
  }

  return (
    <div className="relative w-full h-96 md:h-[500px] overflow-hidden rounded-xl shadow-lg">
      {/* Slides */}
      <div
        className="flex transition-transform duration-500 ease-in-out h-full"
        style={{ transform: `translateX(-${currentSlide * 100}%)` }}
      >
        {slides.map((slide) => (
          <div key={slide.id} className="w-full h-full flex-shrink-0 relative">
            <img
              src={slide.image || "/placeholder.svg"}
              alt={slide.title}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.src = "/placeholder.svg?height=500&width=800&text=Image+Loading"
              }}
            />
            <div className="absolute inset-0 bg-black/40 flex items-end">
              <div className="p-6 text-white">
                <h3 className="text-2xl font-bold mb-2">{slide.title}</h3>
                <p className="text-lg opacity-90">{slide.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Navigation Arrows */}
      <button
        onClick={prevSlide}
        className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full p-2 transition-colors"
        aria-label="Previous slide"
      >
        <ChevronLeft className="w-6 h-6 text-white" />
      </button>

      <button
        onClick={nextSlide}
        className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full p-2 transition-colors"
        aria-label="Next slide"
      >
        <ChevronRight className="w-6 h-6 text-white" />
      </button>

      {/* Dots Indicator */}
      <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => goToSlide(index)}
            className={`w-3 h-3 rounded-full transition-colors ${index === currentSlide ? "bg-white" : "bg-white/50"}`}
            aria-label={`Go to slide ${index + 1}`}
          />
        ))}
      </div>
    </div>
  )
}
